import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-manejo-errores',
  templateUrl: './manejo-errores.component.html',
  styleUrls: ['./manejo-errores.component.css']
})
export class ManejoErroresComponent implements OnInit {
  errorCode: string | null = null;
  errorMessage: string = '';

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.route.queryParamMap.subscribe(params => {
      this.errorCode = params.get('error');
      this.handleErrorCode();
    });
  }

  handleErrorCode(): void {
    switch (this.errorCode) {
      case 'email_not_verified':
        this.errorMessage = 'Tu correo electrónico no está verificado. Por favor, verifica tu correo para continuar.';
        break;
      default:
        this.errorMessage = 'Ha ocurrido un error desconocido.';
        break;
    }
  }

  /*
  resendVerificationEmail(): void {
    console.log('Reenviando correo de verificación...');
    // Aquí podrías llamar a un servicio que maneje el reenvío.
  }
  */  
}
